import apiFetch from '../apiFetch'
export default function (cif) {
  return apiFetch({ endPoint: `User/ExistCif/${cif}`, method: 'GET', body: null })
}
